import React from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { ICustomer } from '../../lib/types';
import { customersAtom } from '../../recoil/customers';
import { customerPagingAtom } from '../../recoil/customer-paging';
import './customer-paging.scss';

export default function CustomerPaging(): JSX.Element {
   const backArrowSvg: URL = new URL(
      '/public/images/back-arrow.svg',
      import.meta.url
   );

   const customer: ICustomer[] = useRecoilValue(
      customersAtom
   );

   const [currentPage, setCurrentPage] = useRecoilState(customerPagingAtom);
   const nextPage = () => {
      if ((currentPage + 1) * 25 < customer.length) {
         setCurrentPage(currentPage + 1);
      }
   };
   const prevPage = () => {
      if (currentPage > 0) {
         setCurrentPage(currentPage - 1);
      }
   };
   const firstPage = () => {
      setCurrentPage(0);
   };
   const lastPage = () => {
      setCurrentPage(Math.ceil(customer.length / 25) - 1);
   };

   return (
      <div className="customer-paging-control">
         <button
            className="tiny-button customer-paging-button"
            onClick={firstPage}
         >
            <img src={backArrowSvg.toString()} />
            <img src={backArrowSvg.toString()} />
         </button>
         <button className="tiny-button customer-paging-button" onClick={prevPage}>
            <img src={backArrowSvg.toString()} />
         </button>
         <div className="customer-paging-message body-small-regular">
            showing {Math.min(customer.length, currentPage * 25 + 1)}-
            {Math.min((currentPage + 1) * 25, customer.length)} of{' '}
            {customer.length}
         </div>
         <button className="tiny-button customer-paging-button" onClick={nextPage}>
            <img
               src={backArrowSvg.toString()}
               className="customer-paging-arrow-back"
            />
         </button>
         <button className="tiny-button customer-paging-button" onClick={lastPage}>
            <img
               src={backArrowSvg.toString()}
               className="customer-paging-arrow-back"
            />
            <img
               src={backArrowSvg.toString()}
               className="customer-paging-arrow-back"
            />
         </button>
      </div>
   );
}
